import { createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "app/error";
import { RootState } from "@myRedux/store";
import { ApiCallState, ApiCallStatus, getHateoasElement } from "@myRedux/networkState";
import { createAppAsyncThunk } from "@myRedux/createAppAsyncThunk";

export interface RefreshTokenState extends ApiCallState<undefined> {
}

const initialState = {
  status: ApiCallStatus.Idle,
} as RefreshTokenState;

export const updateAccessTokenWithRefreshTokenAsync = createAppAsyncThunk(
  'session/updateAccessTokenWithRefreshToken',
  async (_, thunkAPI) => {
    try {
      const response = await thunkAPI.extra.authClient.get('auth/token/refresh');
      if (response.hasError()) {
        if (response.status === 401) {
          return thunkAPI.rejectWithValue('UNAUTHORIZED');
        }
        return thunkAPI.rejectWithValue(response.statusText);
      }
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateAccessTokenWithRefreshTokenSlice = createSlice({
  name: 'updateAccessTokenWithRefreshToken',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAccessTokenWithRefreshTokenAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(updateAccessTokenWithRefreshTokenAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Idle;
      })
      .addCase(updateAccessTokenWithRefreshTokenAsync.rejected, (state) => {
        state.status = ApiCallStatus.Failed;
      });
  },
});

export const selectRefreshTokenStatus = (state: RootState) => state.session.refreshToken.status;

export default updateAccessTokenWithRefreshTokenSlice.reducer;